import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {DetectMethodChanges} from '../utils';
import {HedgePresetClient} from './hedge-preset-client.service';
import {SessionService} from '../authentication/session-service.service';
import {HedgePresetDesignerComponent} from './hedge-preset-designer.component';

@Component({selector: 'ets-hedge-preset-launcher', changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<ng-container *ngIf="client.canManage && session.isSuperUser">
      <dx-popup title="Hedging Presets" [visible]="visible" [width]="425" height="auto" maxWidth="95vw" maxHeight="90vh"
        [showCloseButton]="true" [dragEnabled]="true" [closeOnOutsideClick]="false" (onShown)="onShown()" (onHidden)="close()">
        <div *dxTemplate="let data of 'content'">
          <ets-hedge-preset-designer *ngIf="visible" [underlying]="underlying"></ets-hedge-preset-designer>
        </div>
      </dx-popup>
    </ng-container>`})
export class HedgePresetLauncherComponent {
    @Input() underlying = 'SPX';
    @ViewChild(HedgePresetDesignerComponent) designer: HedgePresetDesignerComponent;
    visible = false;
    constructor(public readonly client: HedgePresetClient, private readonly _changeDetector: ChangeDetectorRef,
        public readonly session: SessionService) {}
    @DetectMethodChanges() open(): void { if (this.client.canManage && this.session.isSuperUser) { this.visible = true; } }
    onShown(): Promise<void> {
        if (this.visible && this.designer) { return this.designer.onShown(); }
        return Promise.resolve();
    }
    @DetectMethodChanges() close(): void { this.visible = false; }
}
